/**
 * Created by Jan Bradac on 2.1.2016.
 */

/**
 * Enables a "soft" replacement of a HTML element with another HTML by hiding the first one.
 *
 * TODO MOBA II - move to namespace. Probably the Lfl.Helpers
 *
 * @type {{}}
 */
ElementSoftSwapper = {
    swapForNew: function(elementToHide, htmlToShow) {
        var width = elementToHide.outerWidth();
        var height = elementToHide.outerHeight();

        var elementToShow = $(htmlToShow);

        elementToHide.hide();

        elementToShow.insertAfter(elementToHide);

        //If there was any content before then adjust the dimensions to the original dimensions.
        if(width != 0) {
            elementToShow.outerWidth(width);
            elementToShow.outerHeight(height);
        }

        return elementToShow;
    }
};